import { Home, Truck, DocumentText, Message, Box1, Wallet1, PresentionChart, TableDocument, Back, ClipboardText, Printer, Ticket } from "iconsax-react";

const pages = [
    {
        id: "home",
        title: "Home",
        icon: <Home size={18} />,
        navLink: "/dashboard",
    },
    {
        header: "Reports",
    },
    {
        id: "orders",
        title: "Orders",
        icon: <Box1 size={18} />,
        navLink: "/orders",
        group: "Reports"
    },
    {
        id: "deliveries",
        title: "Deliveries",
        icon: <Truck size={18} />,
        navLink: "/deliveries",
        group: "Reports"
    },
    {
        id: "invoices",
        title: "Invoices",
        icon: <DocumentText size={18} />,
        navLink: "/invoices",
        group: "Reports"
    },
    {
        header: "Payments",
    },
    {
        id: "create-payment",
        title: "Make Payment",
        icon: <Wallet1 size={18} />,
        navLink: "/payments",
        group: "Payments"
    },
    {
        id: "payment-history",
        title: "Payment History",
        icon: <TableDocument size={18} />,
        navLink: "/payment-reports",
        group: "Payments"
    },
    {
      header: "Support Desk",
    },
    {
      key: "support-desk-dashboard",
      id: "support-desk-dashboard",
      title: "Dashboard",
      icon: <PresentionChart size={18} />,
      navLink: "/support-desk/dashboard",
      group: "Support Desk",
    },
    {
      key: "support-desk-tickets",
      id: "support-desk-tickets",
      title: "Tickets",
      icon: <Ticket size={18} />,
      navLink: "/support-desk/tickets",
      group: "Support Desk",
    },
    {
        header: "Others",
    },
    {
        id: "service-calls",
        title: "Service Calls",
        icon: <Message size={18} />,
        navLink: "/service-calls",
        group: "Others"
    },
    {
        id: "return-request",
        title: "Return Request",
        icon: <Back size={18} />,
        navLink: "/return-request",
        group: "Others"
    },
    {
        id: "contracts",
        title: "Contracts",
        icon: <ClipboardText size={18} />,
        navLink: "/contracts",
        group: "Others"
    },
    {
        id: "label-print",
        title: "Label Print",
        icon: <Printer size={18} />,
        navLink: "/label-print",
        group: "Others"
    },
];

export default pages;